export const clientNameFooter = "ANA OUTSUBO";
export const titleMain = "";
export const subtitleMain = "";

export const aspectRatioLogoAbout = '1'; // width/height
export const aspectRatioLogoMain = '1'; // width/height

export const borderRadiusButtons = '10px';

export const nomeFornecedorCompleto = "ANA OUTSUBO";
export const nomeFornecedor = "ANA OUTSUBO";
export const artigo = "a";
export const artigoCaps = "A";

export const footerSocialData = [
  {
    type: "material-community",
    name: "instagram",
    link: "",
    profile: ""
  },
  {
    type: "material-community",
    name: "whatsapp",
    link: "",
    number: ""
  },
];

export const drawerClosedLinks = [
  // {
  //   title: "Fale Comigo",
  //   link: "https://wa.me/+5511985882856",
  // },
];

export const linkAppleStore = null
export const linkPlayStore = null

export const hasOutsideAboutPage = true;
export const drawerOpenedLinks = [];